import { render, staticRenderFns } from "./AboutAlliance.vue?vue&type=template&id=30582f61"
import script from "./AboutAlliance.vue?vue&type=script&lang=js"
export * from "./AboutAlliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports